

class ModalComponent extends HTMLElement {
    static get observedAttributes() {
        return ["items", "open", "colors", "id"];
    }
    constructor() {
        super();
        this.form_id = null
        this.attachShadow({ mode: 'open' });
    }

    async addToCart(e) {
        if (e.target.getAttribute('type') == 'submit') return;
        const id = this.getVariant()?.variant?.id.replace(/.+\//, '')
        const currentCart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

        const existingItem = currentCart.items.find(item => {
            return item.variant_id == id;
        });

        try {
            const cartSectionId = document.querySelector("#cart-drawer").parentNode.id.replace(/shopify-section-/, '')

            const payload = {
                sections_url: `${Shopify.routes.root}variants/${id}`,
                sections: ['variant-added', cartSectionId],
                items: [{
                    id,
                    quantity: 1
                }]
            }

            let json = null
            if (existingItem) {
                payload.items[0].quantity = existingItem.quantity + 1
                payload.items[0].id = existingItem.key
                payload.items[0].sections = ['variant-added', cartSectionId]
                json = await CartUpdate(payload.items[0])
            } else {
                json = await CartAdd(payload)
            }
            console.log('json:', json)

            // If cart Error run message 
            if (json.status) {
                console.log('cart error status:', json.description)
                this.cartErrorMessage.classList.add('--error')
                this.cartErrorMessage.textContent = json.description
            } else {
                const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                cartContent["sections"] = json["sections"];
                const cartDrawerType = window.themeVariables.settings.cartType !== "drawer" ? document.getElementsByClassName('quick-buy-drawer')[0] : document.querySelector('cart-drawer.cart-drawer')
                cartDrawerType.dispatchEvent(new CustomEvent("variant:add", {
                    bubbles: true,
                    detail: {
                        items: json.hasOwnProperty("items") ? json["items"] : [json],
                        cart: cartContent
                    }
                }));
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: cartContent
                    }
                }));
                this.remove()
            }
        } catch (error) {
            console.log('cart error:', error)
            this.cartErrorMessage.classList.add('--error')
            this.cartErrorMessage.textContent = typeof json === 'undefined' ? error : json.description ?? error
        }
    }

    async getProducts(ids) {
        const response = await fetch(`https://order-api.studiomcgee.com/products`, {
            // const response = await fetch(`http://127.0.0.1:5050/products`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include',
            body: JSON.stringify({ ids })
        });
        return await response.json()
    }


    attributeChangedCallback(attr, oldValue, newValue) {
        // Array of ids as a JSON string 
        if (attr === 'items') {
            // Items attribute is changed to array of ids
            if (newValue.length) {
                this.getProducts(newValue).then(products => {
                    this.products = products
                }).catch(err => console.log('server response err:', err))
            }
        }

         // Single id of a String
         if (attr === 'id') {
            const new_product = this.products.nodes.find(p => p.id === newValue)
            this.product = new_product
            console.log('new_product:', new_product)
            this.render(new_product)
            const swipe_carousel = this.shadowRoot.querySelector('swipe-carousel');
            const media = new_product.media
            swipe_carousel.setAttribute('media', JSON.stringify(media))
            this.addEventListeners()
            this.check_selection_combinations()
        }

        if (attr === 'colors') {
            this.color_arr = newValue.split(/\r?\n/)
        }
    }

    getVariant() {
        let product = this.product
        const dropdownSelectors = Array.from(this.shadowRoot.querySelectorAll('.variant-picker input:not(.FAKE_VALUE):checked'))

        if (!dropdownSelectors.length) {
            return { variant: product.variants[0], checkedTitle: product.title }
        }

        const checkedTitle = dropdownSelectors.map(el => el.value).join(' / ')
        const index = product.variants.findIndex(variant => variant.title === checkedTitle)
  
        if (Number(checkedTitle)) {
            index = 0
        }

        const variant = product.variants[index]

        if (!variant) {
            console.log('getVariant is false');
            return { variant: null, checkedTitle }
        }
        return { variant, checkedTitle }
    }

    scrollImgIntoView() {
        const { variant } = this.getVariant()
        if (!variant) return;
        const img_url = variant.image.url
        const index = this.product.media.findIndex(m => m.preview.image.url === img_url);

        if (index > -1) {
            const swipe_carousel = this.shadowRoot.querySelector('swipe-carousel');
            swipe_carousel.shadowRoot.querySelectorAll('.c-carousel-item')[index]
            .scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
    }

    updatePrice() {
        const { variant } = this.getVariant()
        if (!variant) return;
        let price = this.comma_separated_number(variant.price)
        let compare_at_price = variant.compare_at_price

        if (compare_at_price) {
            this.elements.compare_at_price.removeAttribute('hidden')
            this.shadowRoot.querySelector('.price-list > p:nth-child(2)').textContent = `$${this.comma_separated_number(variant.price)}`
        }
        this.shadowRoot.querySelector('.price-list > p').textContent = `$${price}`
    }

    updateOptionTitle(inputNameValue, val) {
        this.shadowRoot.querySelector(`[data-option="${inputNameValue}"]`).textContent = val
    }

    isSelectionAvailable() {
        const { variant } = this.getVariant()
        const addToCartButton = this.shadowRoot.querySelector('.buy-buttons button')
        if (!variant || !variant.availableForSale) {
            addToCartButton.setAttribute('disabled', '')
            addToCartButton.textContent = 'Sold Out'
        } else {
            addToCartButton.removeAttribute('disabled')
            addToCartButton.textContent = 'Buy It Now'
        }
    }

    check_selection_combinations(e) {
        const productVariants = this.product.variants
        const options = this.product.options
        const clickedOptionOne = this.shadowRoot.querySelector(`[name="option1"]:checked`)
        const option1_checked_val = clickedOptionOne?.value
        const filteredVariants = productVariants.filter(variant => variant.selectedOptions[0].value === option1_checked_val)

            /* End Remove when products all duplicated */
            if (options.length) options.forEach((option, i) => {
                let checkedInputRemoved_index = null
                // We skip 0 index because that is the first option that is always available
                if (i) {
                    const optionElements = Array.from(this.shadowRoot.querySelectorAll(`[name="option${i + 1}"]`))
                    const prevElement = this.shadowRoot.querySelector(`[name="option${i}"]:checked`)
         
                    optionElements.reduce((previous_checked_el, el) => { 
                        const foundVariant = filteredVariants.find((variant) => {
                            // console.log(previous_checked_el, ' | ',variant.selectedOptions[i-1].value, ':', el.value, ' | ',  variant.selectedOptions[i].value)
                            return previous_checked_el === variant.selectedOptions[i-1].value && el.value === variant.selectedOptions[i].value
                        })

                        /* DOESNT EXIST */
                        if (!foundVariant) {
                            if (el.checked) checkedInputRemoved_index = i + 1
                            el.style.display = 'none'
                            el.nextElementSibling.setAttribute('hidden', '')
                            /* EXISTS */
                        } else {
                            el.removeAttribute('style')
                            el.nextElementSibling.removeAttribute('hidden')
                            if(!foundVariant.availableForSale) { 
                                el.nextElementSibling.classList.add('is-disabled')
                                clickedOptionOne.nextElementSibling.classList.add('is-disabled')
                                console.log('previous_checked_el:', previous_checked_el, prevElement)
                            }
                        }
                        return previous_checked_el
                    }, prevElement.value)

                    // Check first option true if checked option was removed above
                    if (typeof checkedInputRemoved_index === 'number') {
                        const firstInput = this.shadowRoot.querySelector(`[name="option${checkedInputRemoved_index}"]:not([style]`)

                        if (firstInput) {
                            firstInput.checked = true
                        }
                    }
                }
            })
        this.isSelectionAvailable()
        this.updatePrice()
        this.scrollImgIntoView()
        if(e) {
            const option_name = e.target.getAttribute('name')
            const option_value = e.target.value
            this.updateOptionTitle(option_name, option_value)
        }
    }

    remove() {
        this.shadowRoot.innerHTML = ''
    }

    addEventListeners() {
        // Close modal
        this.shadowRoot.querySelectorAll('.overlay, .quick-buy-modal__close-button')?.forEach(el => el.addEventListener('click', (e) => this.remove()))
        // Option selectors
        this.shadowRoot.querySelector('.variant-picker')?.addEventListener('click', e => e.target.nodeName === 'INPUT' && this.check_selection_combinations(e))
        // Buy It Now button
        this.shadowRoot.querySelector('.buy-buttons button')?.addEventListener('click', e => this.addToCart(e))
    }


    comma_separated_number(price) {
       return Number(price).toFixed(2).toLocaleString('en-US')
    }

    getColorCode(color, colors) {
        const value = new RegExp(`(^|\s)${color}:`, "gi");
        for (const color of colors) {
            if (color.match(value)) {
 
                const swatch_color = color.split(': ')[1] || null
                if (/\./.test(swatch_color)) {
                    return { image: true, color: swatch_color.trim() }
                }
                return { image: false, color: swatch_color.trim() }

            }
        }
        // If this runs it gives back the color as it is probably a primary color and doesn't need a hex code
        return { image: false, color: color.trim() }
    }

    createOptionSelections(option, i) {
        return option.values.map((value, value_index) => {
            const escaped_value = value.replace(/'/g, "\\'")
            if (['color'].includes(option.name.toLowerCase())) {
                
                const { image, color } = this.getColorCode(value, this.color_arr)

                return (
                    image ? `
                    <input class="sr-only" type="radio" name="option${i + 1}" id='option${i}${value}' data-id="" data-ids="" value='${value}' data-option-name="" ${!value_index && 'checked'}>
                    <label class="color-swatch" for="option${i}${value}" style="--swatch-background: url(/cdn/shop/files/${color}?width=72)" value='${value}'>
                        <span class="sr-only">${value}</span>
                    </label>`
                        :
                        `<input class="sr-only" type="radio" name="option${i + 1}" id='option${i}${value}' data-id="" data-ids="" value='${value}' data-option-name="" ${!value_index && 'checked'}>
                    <label class="color-swatch" for="option${i}${value}" style="--swatch-background: linear-gradient(to right, ${color}, ${color})" value='${value}'>
                        <span class="sr-only">${value}</span>
                    </label>`
                )
            } else {
                return (
                    `<input class="sr-only" type="radio" name='option${i + 1}' id='option${i}${value}' data-id='' data-ids='' value='${escaped_value}' data-option-name='' ${!value_index && 'checked'}>
                    <label class="block-swatch" for='option${i}${value}' value='${escaped_value}'>
                        <span>${value}</span>
                    </label>`
                )

            }
        }).join('')
    }

    render(product) {
        this.shadowRoot.innerHTML = `
        
            <style>
                :host {
                    position: relative;
                    z-index: 500;
                }
                .modal-component::part(base), .base {
                    place-items: center;
                }               
                .modal-component::part(overlay), .overlay{
                    background: rgb(0,0,0,.4);
                    min-height: 100vh;
                    position: fixed;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                }
                .modal-component::part(content), .content{
                    position: relative;
                    max-height: 85dvh;
                    max-width: 55.625rem;
                    background-color: #fff;
                    background-image: var(--background-gradient);
                    color: #1c1c1c;
                    isolation: isolate;
                    width: 100%;
                    max-height: 75vh;
                    overflow: auto;
                }
                .modal-component::part(body), .body {
                        padding-block-start: 3.125rem;
                        padding-block-end: 3.125rem;
                        padding-inline-start: 3.125rem;
                        padding-inline-end: 3.125rem;
                }
                @media screen and (min-width: 700px) {
                    .modal-component::part(base), .base {
                        place-items: center;
                        width: 100%;
                        height: 100%;
                        display: grid;
                        position: fixed;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                    }
                    .quick-buy-modal__content {
                        grid-template-columns: minmax(0, 0.9fr) minmax(0, 1fr);
                        align-items: center;
                        column-gap: 2.5rem;
                        display: grid;
                    }
                }
                quick-buy-modal__content {
                    grid-template-columns: minmax(0, 1fr);
                    display: grid;
                }
                .quick-buy-modal__close-button {
                    cursor: pointer;
                    border: none;
                    background-color: #0000;
                    position: absolute;
                    inset-block-start: 1.875rem;
                    inset-inline-end: 1.875rem;
                    button>.sr-only, button>span {
                        pointer-events: none;
                    }
                    .icon {
                        vertical-align: middle;
                        height: auto;
                        transition: transform .2s;
                        display: block;
                    }
                }
                quick-buy-modal__gallery-wrapper {
                    flex: 1;
                }
                quick-buy-modal__info-wrapper {
                    flex: 1;
                }
                .price-list {
                    flex-wrap: wrap;
                    align-items: baseline;
                    column-gap: .5rem;
                    display: flex;
                }
                .pdp-price {
                    font-family: neuehaas-regular;
                    font-size: 18px !important;
                    line-height: 150%;
                    letter-spacing: .9px;
                    font-weight: 450;
                }
                .text-on-sale {
                    color: #ca462a;
                }
                .line-through {
                    text-decoration: line-through;
                }
                .product-title {
                    margin: 0;
                }
                .h4 {
                    font-family: saintecolombe-light;
                    font-size: 24px;
                    line-height: 130%;
                    letter-spacing: -.48px;
                    font-weight: 300;
                }
                a {
                    color: #1c1c1c;
                    text-decoration: none;
                }
                [hidden] {
                    display: none !important;
                }
                .variant-picker {
                    grid-template-columns: minmax(0, 1fr);
                    align-content: start;
                    display: grid;
                    gap: 1.25rem;
                    .variant-picker__label {
                        gap: 0.25rem;
                        align-items: center;
                        display: flex;
                    }
                }
                .variant-picker__option {
                    grid-template-columns: minmax(0, 1fr);
                    align-content: start;
                    display: grid;
                    gap: .625rem;
                }
                .paragraph-sm-bold {
                    font-family: neuehaas-bold;
                    font-size: 14px;
                    line-height: 150%;
                    letter-spacing: .7px;
                    font-weight: 500;
                }
                .paragraph-sm {
                    font-family: neuehaas-regular;
                    font-size: 14px;
                    line-height: 150%;
                    letter-spacing: .7px;
                    font-weight: 450;
                }
                .color-swatch {
                    --swatch-disabled-strike-color: rgb(221 221 221);
                    width: 3rem;
                    height: 3rem;
                    padding: 2px;
                    border: 1px solid transparent;
                    background: content-box var(--swatch-background) no-repeat center / cover;
                    place-items: center;
                    display: grid;
                    position: relative;
                    border-radius: 100px;
                }
                :checked+.color-swatch, .color-swatch.is-selected {
                    --swatch-disabled-margin: 0;
                    --swatch-disabled-strike-color: currentColor;
                    border-color: currentColor;
                }
                .variant-picker__option-values {
                    gap: .625rem;
                    align-items: center;
                    display: flex;
                    flex-wrap: wrap;
                }
                .sr-only {
                    clip: rect(0, 0, 0, 0);
                    white-space: nowrap;
                    border-width: 0;
                    width: 1px;
                    height: 1px;
                    margin: -1px;
                    padding: 0;
                    position: absolute;
                    overflow: hidden;
                }
                label {
                    -webkit-tap-highlight-color: transparent;
                    touch-action: manipulation;
                    cursor: pointer;
                }
                .block-swatch {
                    --swatch-border-size: 1px;
                    --swatch-disabled-strike-color: rgb(221 221 221);
                    color: #2c2c2c;
                    justify-content: center;
                    align-items: center;
                    column-gap: .875rem;
                    min-width: 2.5rem;
                    display: flex;
                    position: relative;
                    border: 1px solid #B4B1B1;
                    font-family: neuehaas-regular;
                    font-weight: 450;
                    line-height: normal;
                    letter-spacing: .7px;
                    padding: 18px 20px;
                }
                :checked+.block-swatch, .block-swatch.is-selected {
                    color: #fff;
                    border: 1px solid #2C2C2C;
                    background: #2C2C2C;
                }
                .block-swatch.is-disabled {
                    color: rgb(28 28 28 / .5);
                }
                .buy-buttons {
                    margin-block-start: 20px;
                    margin-block-end: 20px;
                    button {
                        background: #2c2c2c;
                        border: 1px solid #2c2c2c;
                        padding: 18px 25px;
                        color: #fff;
                        text-align: center;
                        font-family: neuehaas-regular;
                        font-size: 14px;
                        font-weight: 450;
                        line-height: normal;
                        letter-spacing: 1.4px;
                        text-transform: uppercase;
                        width: 100%;
                        text-transform: uppercase;
                        margin: 0;
                        opacity: 1;
                        transition: .4s;
                        &:hover {
                            background: #3F3E39;
                        }
                    }
                }
                hr {
                    border-color: #ffffff;
                }
                .quick-buy-modal__view-more {
                    font-family: neuehaas-regular;
                    font-size: 14px;
                    font-weight: 450;
                    line-height: normal;
                    letter-spacing: .7px;
                    text-decoration: underline;
                    text-underline-offset: 2px;
                    opacity: 1;
                    transition: .4s;
                    margin-block-start: 25px;
                    display: inline-block;
                     &:hover {
                        color: #656159;
                        text-decoration: underline;
                    }
                }
                .color-swatch.is-disabled::before {      
                    content: "";
                    margin: 2px;
                    background: linear-gradient(to bottom right, transparent calc(50% - .5px), currentColor calc(50% - .5px) calc(50% + .5px), transparent calc(50% + .5px));
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                }
                .block-swatch.is-disabled::before {      
                    content: "";
                    margin: 2px;
                    background: linear-gradient(to bottom right, transparent calc(50% - .5px), currentColor calc(50% - .5px) calc(50% + .5px), transparent calc(50% + .5px));
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                }
                input:checked + .block-swatch.is-disabled {
                    color: rgb(255 255 255 / .5);
                }
                .buy-buttons button {
                    cursor: pointer;
                }
                
            </style>
            <div part="base" class="base">
                <div part="overlay" class="overlay"></div>
                <div part="content" class="content">
                    <div part="body" class="body">
                        <div id="mcgee-quick-buy-content">
                            <div part="quick-buy-modal__content">
                                <button type="button" class="quick-buy-modal__close-button sm-max:hidden" is="dialog-close-button">
                                    <span class="sr-only">Close</span><svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-close" viewBox="0 0 16 16">
                                    <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.1"></path>
                                    </svg>
                                </button>
                                <div class="quick-buy-modal__gallery-wrapper">
                                    <swipe-carousel></swipe-carousel>
                                </div>
                                <div class="quick-buy-modal__info-wrapper">
                                    <div class="product-info__block-list">
                                        <a href="${product.onlineStoreUrl}">
                                            <h4 class="product-title h4">${product.title}</h2>
                                        </a>
                                        ${(() => {
                                            return (
                                                `<div class="price-list">
                                                    <p form="${this.form_id && this.form_id}" class="plp-price ${product.compareAtPriceRange ? 'text-on-sale pdp-price' : 'text-subdued pdp-price'}">
                                                        $${(() => this.comma_separated_number(product.priceRangeV2.minVariantPrice.amount))()}
                                                    </p>
                                                    <p form="${this.form_id && this.form_id}" ${!product.compareAtPriceRange && 'hidden'} class="plp-price h5 text-subdued line-through pdp-price">
                                                        $${(() => this.comma_separated_number(product.priceRangeV2.minVariantPrice.amount))()}
                                                    </p>
                                                </div>`
                                            )
                                        })()}
                                        <div class="variant-picker">
                                            ${(() => {
                                                product.options.map((option, i) => {
                                                console.log('option:', option)

                                                })
                                                return product.options.map((option, i) =>
                                                (
                                                    `<div class="variant-picker__option">
                                                        <div class="variant-picker__label">
                                                        <label class="paragraph-sm-bold" for="${option.name}">${option.name}:</label>
                                                            <span class="paragraph-sm option-value" data-option='option${i+1}'> ${option.values[0]}</span>
                                                        </div>
                                                        <div class="variant-picker__option-values">
                                                            ${this.createOptionSelections(option, i)}
                                                        </div>
                                                    </div>`
                                                )
                                                ).join('')
                                            })()}
                                        </div>
                                        <div class="buy-buttons">
                                            <button>Buy It Now</button>
                                        </div>
                                        <hr>
                                        <a href="${product.onlineStoreUrl}" class="quick-buy-modal__view-more">View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
customElements.define('modal-component', ModalComponent);

